import { observer } from "mobx-react";
import './index.css';
import { useNavigate, useParams } from "react-router";
import VestelHeader from "../../components/VestelHeader";
import DashboardSideBar from "../../components/DashboardSideBar";
import { useContext, useEffect, useState } from "react";
import { backIcon, cancelIcon, downloadIcon, saveIcon } from "../../assets";
import strings from "../../localization";
import CallSelectIssue from "../../components/CallSelectIssue";
import CallStore from "../../stores/CallStore";
import TechCallSessionNotes from "../../components/TechCallSessionNotes";
import TechCallChat from "../../components/TechCallChat";
import CallSessionInformationWithRecords from "../../components/CallSessionInformationWithRecords";
import { SelffixLoadingContext } from "../../contexts/SelffixLoadingContext";
import { ModalAlertContext } from "../../contexts/ModalAlertContext";

const SessionInformationView = () => {

  const navigate = useNavigate();
  const { slug } = useParams();
  const { showSelffixLoading, closeSelffixLoading } = useContext(SelffixLoadingContext);
  const { showModalAlert, closeModalAlert } = useContext(ModalAlertContext);

  useEffect(() => {
    const getCall = async () => {
      const resp = await CallStore.getCall(slug);
      if (resp.success) {
        return resp;
      } else {
        showModalAlert({
          title: strings.error,
          message: resp.message,
          confirmText: strings.ok,
          type: "error",
          onConfirm: () => {
            closeModalAlert();
          },
          onCancel: null
        });
      }

    }
    getCall();
  }, [slug]);

  const handleCancel = () => {
    navigate(-1);
  }

  const handleSave = async () => {
    showSelffixLoading();
    try {
      const call = CallStore.call;
      if (!call) {
        return;
      }

      const { state, ...callBody } = call;
      const response = await CallStore.updateCall(slug, callBody);
      if (response.success) {
        CallStore.setCall(response.data);
      } else {
        showModalAlert({
          title: strings.error,
          message: response.message,
          confirmText: strings.ok,
          type: "error",
          onConfirm: () => {
            closeModalAlert();
          },
          onCancel: null
        });
        return;
      }

    } catch (error) {
      showModalAlert({
        title: strings.error,
        message: error.message,
        confirmText: strings.ok,
        type: "error",
        onConfirm: () => {
          closeModalAlert();
        },
        onCancel: null
      });
    } finally {
      closeSelffixLoading();
    }
  }

  return <div className="dashboard-layout-view">
    <VestelHeader />
    <div className="dashboard-layout-view-content">
      <DashboardSideBar />
      <div className="dashboard-layout-view-content-right">
        <div className="dashboard-layout-view-content-right-header">
          <button className="button-cta button-cta-medium" onClick={() => navigate(-1)}>
            <img src={backIcon} alt="back" />
            <span>{strings.back}</span>
          </button>
          <span>{strings.sessionInformation}</span>
        </div>

        <div className="dashboard-layout-view-content-scroll-body">
          <CallSessionInformationWithRecords />
          <CallSelectIssue />

          <div className="session-information-view-content-scroll-body-middle">
            <TechCallSessionNotes />
            <TechCallChat isPreview={true} />
          </div>
        </div>

        <div className="dashboard-layout-view-content-bottom">
          <button className="button-cta button-cta-medium" onClick={handleCancel}>
            <img src={cancelIcon} alt="cancel" />
            <span>{strings.cancel}</span>
          </button>
          <button className="button-cta-secondary button-cta-secondary-medium" onClick={handleSave}>
            <img src={saveIcon} alt="save" />
            <span>{strings.save}</span>
          </button>
        </div>

      </div>
    </div>
  </div>
};

export default observer(SessionInformationView);
